import { reactive } from 'vue';

class DialogController {
  show = false;
  component: any = {};
  props: any = {};
  action: any = () => {};
}

const dialogController = reactive(new DialogController());
export { dialogController };
